import { get } from 'lodash';

const getIsAutostartTVEnabled = state =>
  get(state, ['autostartTV', 'data', 'isAutostartTVEnabled']);

export default state => {
  return {
    isAutostartTVEnabled: getIsAutostartTVEnabled(state),
  };
};
